import * as React from 'react';
import { selectionReportTranslations } from '../constants';
import { STATE } from 'app/constants';
import { api } from './api';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { SelectionReportView } from 'app/area/reports/selection/selection-report-view';
import { 
  useContainerComponents, 
  useSelectors,
  useWorkingDefinitionFavouriteId
} from 'app/area/reports/hooks';
import { 
  useShouldInitiallyOpenPanel 
} from 'app/area/reports/selection/hooks';
import { useWorkingDefinitionAggregationState } from 'app/area/reports/containers/aggregation/hooks';
import { useWorkingDefinitionTargetApplication } from 'app/area/reports/containers/target/hooks';
import { useWorkingDefinitionSelectedGroupByFields } from 'app/area/reports/containers/group-by/hooks';
import { useInstanceOptions } from 'app/area/favourite/favourite-context';
import { StatisticalReportExternalProps } from 'app/area/reports/types';

export function SelectionReportContainer({
  drillDown, requestCustomWidth, reflowHandle
}: StatisticalReportExternalProps) {

  const {
    hideVisualizationOptions
  } = useInstanceOptions();

  const favouriteId = useWorkingDefinitionFavouriteId();
  
  const translation = useTranslation(STATE.selectionReport, selectionReportTranslations);

  const initiallyOpen = useShouldInitiallyOpenPanel();

  const {
    selectedAggregationField,
    selectedAggregationFunction,
    selectedUomSet
  } = useWorkingDefinitionAggregationState();

  const selectedTargetApplication = useWorkingDefinitionTargetApplication();

  const selectedGroupByFields = useWorkingDefinitionSelectedGroupByFields();

  const disabledTarget = !selectedAggregationField;

  const {
    aggregateFieldState,
    groupByFieldState,
    targetFieldState,
    chartState
  } = useSelectors();

  const {
    AggregationContainer,
    GroupByContainer,
    TargetContainer,
    ChartContainer
  } = useContainerComponents(api);

  if (!aggregateFieldState || !groupByFieldState || !targetFieldState || !chartState) {
    return null;
  }

  return <SelectionReportView 
    favouriteId={favouriteId}
    aggregateFieldState={aggregateFieldState}
    groupByFieldState={groupByFieldState}
    targetFieldState={targetFieldState}
    chartState={chartState}
    translation={translation}
    initiallyOpen={initiallyOpen}
    AggregationContainer={AggregationContainer}
    GroupByContainer={GroupByContainer}
    TargetContainer={TargetContainer}
    ChartContainer={ChartContainer}
    hideVisualizationOptions={hideVisualizationOptions}
    disabledTarget={disabledTarget}
    selectedAggregationField={selectedAggregationField}
    selectedAggregationFunction={selectedAggregationFunction}
    selectedUomSet={selectedUomSet}
    selectedTargetApplication={selectedTargetApplication}
    selectedGroupByFields={selectedGroupByFields}
    drillDown={drillDown}
    requestCustomWidth={requestCustomWidth}
    reflowHandle={reflowHandle}
  />;
}
